var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', {
    attrs: {
      "small": "",
      "block": "",
      "color": "font-weight-bold"
    },
    on: {
      "click": _vm.copy
    }
  }, [_c('v-row', {
    staticClass: "my-0",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "text-start"
  }, [_vm._v(" " + _vm._s(_vm.link) + " ")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-content-copy")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }